"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.merge = void 0;

var Classify = _interopRequireWildcard(require("../Classify"));

var Objects = _interopRequireWildcard(require("../Objects"));

var Arrays = _interopRequireWildcard(require("../Arrays"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var merge = function merge(first) {
  return function (second) {
    if (!Classify.areSame(first)(second)) {
      throw new TypeError('Cannot merge values of different types!');
    }

    return Classify.caseOf({
      Array: function (_Array) {
        function Array(_x) {
          return _Array.apply(this, arguments);
        }

        Array.toString = function () {
          return _Array.toString();
        };

        return Array;
      }(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            firstArray = _ref2[0],
            secondArray = _ref2[1];

        return Arrays.merge(firstArray)(secondArray);
      }),
      Boolean: function Boolean(bools) {
        return bools[1];
      },
      Date: function (_Date) {
        function Date(_x2) {
          return _Date.apply(this, arguments);
        }

        Date.toString = function () {
          return _Date.toString();
        };

        return Date;
      }(function (dates) {
        return dates[1];
      }),
      Function: function (_Function) {
        function Function(_x3) {
          return _Function.apply(this, arguments);
        }

        Function.toString = function () {
          return _Function.toString();
        };

        return Function;
      }(function (funcs) {
        return funcs[1];
      }),
      Number: function Number(nums) {
        return nums[1];
      },
      Null: function Null() {
        return null;
      },
      Object: function (_Object) {
        function Object(_x4) {
          return _Object.apply(this, arguments);
        }

        Object.toString = function () {
          return _Object.toString();
        };

        return Object;
      }(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            firstObj = _ref4[0],
            secondObj = _ref4[1];

        return Objects.merge(firstObj)(secondObj);
      }),
      String: function String(strings) {
        return strings[1];
      },
      Undefined: function Undefined() {
        return undefined;
      }
    })(function (arr) {
      return arr[1];
    })([first, second]);
  };
};

exports.merge = merge;
//# sourceMappingURL=index.js.map